"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _Button = require("../form/Button");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./ExchangeNavModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bem = (0, _cssClassesHelper.getBEMClasses)('exchange-nav-modal');
var ExchangeNavModalComponent = function ExchangeNavModalComponent(props) {
  var isOpen = props.isOpen,
    onGoToSettings = props.onGoToSettings,
    onClose = props.onClose,
    _props$modalProps = props.modalProps,
    modalProps = _props$modalProps === void 0 ? {} : _props$modalProps;
  var feature = props.feature || modalProps.feature;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var featureMessages = {
    Margin: {
      title: t('Margin'),
      message: t('To trade with leverage, you first need to enable the Margin Trading feature for your user. You will be redirected to the settings page to complete the setup.')
    },
    Futures: {
      title: t('Futures'),
      message: t('To trade with leverage, you first need to enable the Futures Trading feature for your user. You will be redirected to the settings page to complete the setup.')
    }
  };
  var _ref = featureMessages[feature] || {},
    title = _ref.title,
    message = _ref.message;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: title,
    close: onClose,
    customClass: bem('modal')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bem('body')
  }, /*#__PURE__*/_react["default"].createElement("p", null, message)), /*#__PURE__*/_react["default"].createElement("div", {
    className: bem('footer')
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    type: "button",
    onClick: onClose,
    variant: "secondary-color",
    className: "cancel-button"
  }, t('Cancel')), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    type: "button",
    onClick: onGoToSettings,
    className: "go-to-settings-button"
  }, t('Go to Settings'))));
};
ExchangeNavModalComponent.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  feature: _propTypes["default"].oneOf(['Margin', 'Futures']).isRequired,
  onGoToSettings: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ExchangeNavModalComponent;